import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const formatPrice = (n) =>
  new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(n);

const MONTHS_FR = [
  "janvier", "février", "mars", "avril", "mai", "juin",
  "juillet", "août", "septembre", "octobre", "novembre", "décembre",
];

export const formatDateFr = (isoDate) => {
  if (!isoDate) return "";
  const [y, m, d] = isoDate.split("-").map(Number);
  if (!y || !m || !d) return isoDate;
  return `${d} ${MONTHS_FR[m - 1]} ${y}`;
};

export const formatShortDateFr = (isoDate) => {
  if (!isoDate) return "";
  const [y, m, d] = isoDate.split("-").map(Number);
  if (!y || !m || !d) return isoDate;
  const mon = MONTHS_FR[m - 1].slice(0, 3);
  return `${d} ${mon} ${y}`;
};

export const getConcerts = async (params = {}) => {
  const { data } = await api.get("/concerts", { params });
  return data;
};

export const getConcert = async (slug) => {
  const { data } = await api.get(`/concerts/${slug}`);
  return data;
};

export const initCheckout = async (payload) => {
  const { data } = await api.post("/checkout/init", payload);
  return data;
};

export const sendContact = async (payload) => {
  const { data } = await api.post("/contact", payload);
  return data;
};

export const subscribeNewsletter = async (email) => {
  const { data } = await api.post("/newsletter", { email });
  return data;
};
